import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';
import type { GloryGachaEntryDef } from '../../../master-data/types/glory-gacha.types.ts';

// glory_gacha_entry — 글로리 뽑기 확률표 엔트리.
// deliveryItems 는 JSONB 이므로 kind:'json' 으로 통째 보존한다(glory-shop 과 동일).
export const GloryGachaEntrySchema = defineSchema({
  name: 'serverGloryGachaEntries',
  fields: [
    ['id', 'string'],
    ['boxId', 'string'],
    ['weight', 'number'],
    ['deliveryItems', { kind: 'json' }],
    ['nameKey', 'string'],
    ['icon', 'string?'],
    ['rarity', 'string?'],
    ['displayOrder', 'number'],
    ['isActive', 'boolean'],
    // append-only (튜플 와이어 순서 계약) — 신규 필드는 항상 끝에 붙인다.
  ],
  lookupKeys: ['id'],
});

export interface RawGloryGachaEntryRow {
  id: string;
  box_id: string;
  weight: number;
  delivery_items: Record<string, number> | null;
  name_key: string;
  icon: string | null;
  rarity: string | null;
  display_order: number | null;
  is_active: boolean;
}

export function gloryGachaEntryFromRaw(row: RawGloryGachaEntryRow): GloryGachaEntryDef {
  const def: GloryGachaEntryDef = {
    id: String(row.id),
    boxId: String(row.box_id),
    weight: Number(row.weight ?? 0),
    deliveryItems: row.delivery_items ?? {},
    nameKey: String(row.name_key),
    displayOrder: Number(row.display_order ?? 0),
    isActive: Boolean(row.is_active),
  };
  const icon = String(row.icon ?? '').trim();
  if (icon) def.icon = icon;
  const rarity = String(row.rarity ?? '').trim();
  if (rarity) def.rarity = rarity;
  return def;
}

registerCategorySchema('serverGloryGachaEntries', GloryGachaEntrySchema);
